import { v4 as uuidv4 } from 'uuid'
import { t } from 'ttag'

export const getColumns = () => [
  { header: t`candidate`, accessorKey: 'name', alignLeft: true },
  { header: t`GMA`, accessorKey: 'GMA' },
  { header: t`personality`, accessorKey: 'Personality' },
  { header: t`total`, accessorKey: 'Ebber Test Score' },
  { header: t`recommendation` },
  { header: t`tested`, accessorKey: 'completed' },
  { header: t`progress`, accessorKey: 'status' },
  { header: '', id: uuidv4() },
]
